import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CbjLayoutComponent } from './cbj-layout.component';
import {CbjRippleModule } from '../ripple/index';
import { CbjScrollModule } from '../scroll/index';
export class CbjLayoutModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    CbjScrollModule,
    CbjRippleModule,
    RouterModule,
  ],
  declarations: [
    CbjLayoutComponent
  ],
  exports: [
    CbjLayoutComponent,
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CbjLayoutModule_tsickle_Closure_declarations() {
/** @type {?} */
CbjLayoutModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CbjLayoutModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
